module.exports = __webpack_public_path__ + "img/bank_square_top.f90dad55.svg";